import { PostModel } from "common/models/baseModel";

import { useQuery } from "@tanstack/react-query";
import { ITestimonialGridFilter } from "./types";
import { testimonial } from "./query";

export function useListQuery(model: PostModel<ITestimonialGridFilter>) {
  return useQuery(testimonial.list(model));
}

export function useGetQuery(id: number) {
  return useQuery({
    ...testimonial.get(id),
    enabled: id > 0,
  });
}

export function useViewQuery(id: number, isOpen: boolean) {
  return useQuery({
    ...testimonial.view(id),
    enabled: id > 0 && isOpen,
  });
}

export function useBatchValuesQuery() {
  return useQuery(testimonial.batchValues);
}

// export function useMemberLabelValues(label: string, value: string) {
//     return useQuery(testimonial.batchValues);
//   }

export function useMemberLabelValues(
  inputValue: string | null,
  id: string | null
) {
  return useQuery(testimonial.memberLabelValues(inputValue!, id!));
}
